export default __webpack_public_path__ + "static/media/ger-flag.057f5c97.svg";